import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { DEFAULT_GUIDELINES_ITEMS } from "../notice/circular_constant.js";

export default function GuidelineComponent({ items = DEFAULT_GUIDELINES_ITEMS }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        // warm gradient so it’s not plain white
        background:
          "linear-gradient(135deg, rgba(251,191,36,0.10) 0%, rgba(99,102,241,0.06) 100%)",
        border: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CardContent sx={{ p: 2 }}>
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Chip
            size="small"
            label="Guidelines"
            sx={{
              fontWeight: 700,
              letterSpacing: 0.2,
              bgcolor: "warning.main",
              color: "warning.contrastText",
              "& .MuiChip-label": { px: 1 },
            }}
          />
          <Link
            component={RouterLink}
            to="/guidelines"
            underline="none"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              fontSize: 12.5,
              color: "text.secondary",
              "&:hover": { color: "text.primary" },
            }}
            aria-label="View all guidelines"
          >
            View all <ArrowOutwardIcon sx={{ fontSize: 16 }} />
          </Link>
        </Stack>

        <Divider sx={{ mb: 1 }} />

        {/* List */}
        <List
          disablePadding
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 0.5,
          }}
        >
          {items.map((g, idx) => (
            <ListItem
              key={`${g.name}-${idx}`}
              disableGutters
              sx={{
                borderRadius: 1.5,
                px: 1,
                py: 0.75,
                transition: "background-color .2s ease",
                "&:hover": { bgcolor: "action.hover" },
              }}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="open"
                  component={RouterLink}
                  to={g.link || "#"}
                  size="small"
                >
                  <ChevronRightIcon fontSize="small" />
                </IconButton>
              }
            >
              <CardActionArea
                component={RouterLink}
                to={g.link || "#"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 1,
                  py: 0.25,
                }}
              >
                {/* date pill */}
                <Box
                  sx={{
                    width: 46,
                    minWidth: 46,
                    height: 46,
                    borderRadius: 1.5,
                    bgcolor: "common.white",
                    boxShadow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                    color: "warning.dark",
                  }}
                  aria-hidden
                >
                  <Typography sx={{ fontWeight: 800, fontSize: 14 }}>{g.date}</Typography>
                  <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{g.month}</Typography>
                </Box>

                {/* text */}
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontSize: { xs: 13, sm: 13.5 },
                        fontWeight: 600,
                        color: "text.primary",
                      }}
                    >
                      {g.name}
                    </Typography>
                  }
                  sx={{ ml: 0.5, mr: 4 }}
                />
              </CardActionArea>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

// import React from "react";

// export default function GuidelineComponent() {
//   const circular = [
//     {
//       name: "List of Holidays for year 2020 (KGBV and JBAV)",
//       link: "#",
//       date: "14",
//       month: "Jun 23",
//     },
//     {
//       name: "List of Holidays for year 2020 (KGBV and JBAV)",
//       link: "#",
//       date: "14",
//       month: "Jun 23",
//     },
//     {
//       name: "Performance Appraisal 2021",
//       link: "#",
//       date: "14",
//       month: "Jun 23",
//     },
//     {
//       name: "राज्य के 80 आदर्श विद्यालयों में शिक्षकों की सेवा लेने हेतु शिक्षकों द्वारा आवेदन।",
//       link: "#",
//       date: "14",
//       month: "Jun 23",
//     },
//   ];

//   return (
//     <div className="w-full max-w-sm rounded-lg border bg-white shadow-sm p-4">
//     <h3 className="text-sm font-semibold mb-2 text-gray-800">Guidelines</h3>
//     <ul className="space-y-2">
//       {circular.map((item, index) => (
//         <li key={index} className="flex gap-2 items-start">
//           <div className="w-12 h-12 flex flex-col items-center justify-center text-xs bg-yellow-100 text-yellow-700 rounded">
//             <span className="font-bold">{item.date}</span>
//             <span>{item.month}</span>
//           </div>
//           <a href={item.link} className="text-xs text-blue-600 hover:underline">
//             {item.name}
//           </a>
//         </li>
//       ))}
//     </ul>
//   </div>
//   );
// }

      {/* <div
      key="guideline"
        classNameName="nBox nBox-blue"
        style={{
          boxSizing: "border-box",
          background: "rgb(244, 245, 247)",
          padding: "30px",
          borderTop: "5px solid rgb(255, 255, 255)",
          height: "410px",
          borderColor: "rgb(73, 132, 192)",
        }}
      >
        <h2
          className="mb-2"
          style={{
            boxSizing: "border-box",
            lineHeight: 1.2,
            margin: "0px",
            padding: "0px",
            marginTop: "0px",
            fontWeight: 400,
            fontSize: "1.75em",
            marginBottom: "0.5rem",
            fontFamily: "Didot, serif",
          }}
        >
          Latest Circular
        </h2>
        <div className="circular" style={{ boxSizing: "border-box" }}>
          <ul
            style={{
              boxSizing: "border-box",
              margin: "0px",
              padding: "0px",
              marginTop: "0px",
              marginBottom: "0px",
              minHeight: "215px",
              paddingLeft: "0px",
            }}
          >
            {circular.map((e, index) => {
              return (
                <li
                  key={index}
                  style={{
                    boxSizing: "border-box",
                    margin: "0px",
                    padding: "0px",
                    borderBottom: "1px dashed rgb(153, 153, 153)",
                    listStyle: "none",
                    border: "none",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <a
                    href={e.link}
                    target="_blank"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "transparent",
                      textDecoration: "none",
                      padding: "10px 0px",
                      color: "rgb(51, 51, 51)",
                      fontWeight: 400,
                      paddingLeft: "55px",
                      display: "block",
                      position: "relative",
                    }}
                  >
                    <span
                      className="dtLbl"
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        background: "rgb(255, 255, 255)",
                        color: "rgb(0, 0, 0)",
                        position: "absolute",
                        left: "0px",
                        top: "10px",
                        textAlign: "center",
                        fontWeight: 600,

                        fontFamily: "Didot, serif",
                        fontSize: 10,
                      }}
                    >
                      {e.date}
                      <small
                        style={{
                          boxSizing: "border-box",
                          background: "rgb(125, 125, 127)",
                          padding: "3px 6px",
                          color: "rgb(255, 255, 255)",
                          display: "block",
                          fontSize: 15,
                          fontWeight: 200,
                          fontFamily: "Didot, serif",
                        }}
                      >
                        {e.month}
                      </small>
                    </span>
                    {e.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <a
          className="btnStyle1 mt-4"
          href="https://jepc.jharkhand.gov.in/circular"
          style={{
            boxSizing: "border-box",
            backgroundColor: "transparent",
            textDecoration: "none",
            border: "1px solid rgb(137, 137, 137)",
            padding: "5px 10px",
            transition: "all 0.2s ease 0s",
            display: "inline-block",
            color: "rgb(0, 0, 0)",
            marginTop: "1.5rem",
            fontFamily: "Didot, serif",
          }}
        >
          Read More
        </a>
      </div> */}
      {/* <style
        dangerouslySetInnerHTML={{
          __html: `
html {
  box-sizing: border-box;
  font-family: sans-serif;
  line-height: 1.15;
  text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

body {
  box-sizing: border-box;
  margin: 0px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: rgb(33, 37, 41);
  text-align: left;
  background-color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
}
`,
        }}
      /> */}
//     </>
//   );
// }
